var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99998 11.6479C7.87198 11.6479 7.74399 11.5999 7.64799 11.5039L5.35998 8.75194C5.31198 8.68794 5.27998 8.60793 5.27998 8.52793C5.26398 8.28793 5.45598 8.01594 5.71198 8.01594H7.08799V4.79994C7.08799 4.55994 7.31198 4.33594 7.55198 4.33594H8.46399C8.49599 4.33594 8.52799 4.33594 8.54399 4.33594C8.75199 4.38394 8.92798 4.57594 8.91198 4.79994V8.01594H10.288C10.624 8.03194 10.848 8.49593 10.64 8.76793L8.35198 11.5199C8.25598 11.5999 8.12798 11.6479 7.99998 11.6479Z",
    fill: "#4079F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 0.656006C3.95201 0.656006 0.656006 3.936 0.656006 8C0.656006 12.064 3.93601 15.344 8.00001 15.344C12.064 15.344 15.344 12.064 15.344 8C15.344 3.936 12.048 0.656006 8.00001 0.656006ZM8.00001 2.01601C11.312 2.01601 13.984 4.688 13.984 8C13.984 11.312 11.312 13.984 8.00001 13.984C4.68801 13.984 2.01601 11.312 2.01601 8C2.01601 4.688 4.68801 2.01601 8.00001 2.01601Z",
    fill: "#4079F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.dece3e5eb01ef1d117e11f692b1be4a6.svg";
export { ForwardRef as ReactComponent };